import { makeStyles } from '@mui/styles';

export const useTimelineTitleStyles = makeStyles({
  title: {
    fontSize: '15px',
    fontWeight: 400,
    margin: 0
  },
  badge: {
    marginLeft: '5px'
  }
});
